<!-- 丢弃 -->
<!-- 积分兑换页面 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goChangeData">积分兑换</Button>
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="number">
                        <div class="flex-c"> 
                            <Button label="small">{{row.number ? row.number : 0}}</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="state">
                        <div class="flex-c">
                            <i-switch v-model="row.state" size="large" true-color="#FF761D" :true-value="1" :false-value="0">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost label="small">预览溯源码</Button>
                            <Button type="primary" ghost label="small" @click="goChangeData(row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr-24 ml-24">已经选择{{delData.length}}个</span>
                    <Button type="error" ghost label="large" @click="goDel(0)">删除</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"  />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Drawer v-model="changeModal" :title="changeTitle" width="80">
            <Form :model="formData" label-position="right" :label-width="150">
                <div class="form_title">金额设置</div>
                <FormItem label="红包模式:">
                    <Select class="w300" v-model="formData.mode" clearable filterable placeholder="请选择红包模式">
                        <Option v-for="item in modeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="红包数量:">
                    <Input class="w300" type="text" v-model="formData.number" placeholder="请输入红包数量"></Input>
                </FormItem>
                <FormItem label="每份红包金额:">
                    <Input class="w300" type="text" v-model="formData.money" placeholder="请输入每份红包金额"></Input>
                </FormItem>
                <div class="form_title">金额设置</div>
                <FormItem label="产品批次:">
                    <Select class="w300" v-model="formData.batch" clearable filterable placeholder="请选择产品批次">
                        <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="产品名称:">
                    <Select class="w300" v-model="formData.name" clearable filterable placeholder="请选择产品名称">
                        <Option v-for="item in nameList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="产品代理商:">
                    <Select class="w300" v-model="formData.agent" clearable filterable placeholder="请选择产品代理商">
                        <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <div class="form_title">样式设置</div>
                <div class="flex-sa">
                    <FormItem label="LOGO设置:">
                        <div class="form_upload">
                            <Upload
                            class="flex-c"
                            ref="upload"
                            :show-upload-list="false"
                            :format="['jpg', 'jpeg', 'png', 'gif']"
                            :max-size="2048"
                            :on-format-error="handleFormatError"
                            :on-success="logoSuccess"
                            :on-progress="handleProgress"
                            :headers="headers"
                            :action="uploadImg"
                            >
                                <img class="form_img" v-if="formData.logo" :src="imgConfig + formData.logo">
                                <Icon v-else type="ios-add" size="44" color="#AEAEB3"/>
                            </Upload>
                        </div>
                    </FormItem>
                    <FormItem label="活动页面(入口)样式:">
                        <div class="form_upload">
                            <Upload
                            class="flex-c"
                            ref="upload"
                            :show-upload-list="false"
                            :format="['jpg', 'jpeg', 'png', 'gif']"
                            :max-size="2048"
                            :on-format-error="handleFormatError"
                            :on-success="styleSuccess"
                            :on-progress="handleProgress"
                            :headers="headers"
                            :action="uploadImg"
                            >
                                <img class="form_img" v-if="formData.style" :src="imgConfig  + formData.style">
                                <Icon v-else type="ios-add" size="44" color="#AEAEB3"/>
                            </Upload>
                        </div>
                    </FormItem>
                    <FormItem label="活动页面背景:">
                        <div class="form_upload">
                            <Upload
                            class="flex-c"
                            ref="upload"
                            :show-upload-list="false"
                            :format="['jpg', 'jpeg', 'png', 'gif']"
                            :max-size="2048"
                            :on-format-error="handleFormatError"
                            :on-success="backgroundSuccess"
                            :on-progress="handleProgress"
                            :headers="headers"
                            :action="uploadImg"
                            >
                                <img class="form_img" v-if="formData.background" :src="imgConfig  + formData.background">
                                <Icon v-else type="ios-add" size="44" color="#AEAEB3"/>
                            </Upload>
                        </div>
                    </FormItem>
                    <FormItem label="红包样式:">
                        <div class="form_upload">
                            <Upload
                            class="flex-c"
                            ref="upload"
                            :show-upload-list="false"
                            :format="['jpg', 'jpeg', 'png', 'gif']"
                            :max-size="2048"
                            :on-format-error="handleFormatError"
                            :on-success="redSuccess"
                            :on-progress="handleProgress"
                            :headers="headers"
                            :action="uploadImg"
                            >
                                <img class="form_img" v-if="formData.red" :src="imgConfig  + formData.red">
                                <Icon v-else type="ios-add" size="44" color="#AEAEB3"/>
                            </Upload>
                        </div>
                    </FormItem>`
                </div>
                <FormItem label="红包文字1设置:">
                    <Input class="w300" type="text" v-model="formData.text1 " placeholder="请输入红包文字"></Input>
                </FormItem>
                <FormItem label="红包文字2设置:">
                    <Input class="w300" type="text" v-model="formData.text2" placeholder="请输入红包数量"></Input>
                </FormItem>
                <FormItem label="红包文字3设置:">
                    <Input class="w300" type="text" v-model="formData.text3" placeholder="请输入每份红包金额"></Input>
                </FormItem>
                <div class="footer">
                    <Button @click="cancelForm">取消</Button>
                    <Button class="theme-bg ml-24" type="warning" @click="submitForm">确定</Button>
                </div>
            </Form>
        </Drawer>
    </div>
</template>

<script>
// import { useList, delapi } from '@/api/index';
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
export default {
    data() {
        return {
            imgConfig: config.apiUrl + '/',
            uploadImg: config.apiUrl + "/adminapi/file_upload",
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "活动产品", key: "name", align: "center" },
                { title: "活动总金额", key: "all_money", align: "center" },
                { title: "已瓜分金额", key: "money", align: "center" },
                { title: "参与人数", slot: "number", align: "center" },
                { title: "状态", slot: "state", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "300px" },
            ],
            dataTable: [
                { name: "产品名称1", all_money: "20.00元", money: "0.00元", number: "3", state: 1 },
            ],
            changeModal: false,
            changeTitle: "",
            formData: {
                mode: "",
                number: "",
                money: "",
                batch: "",
                name: "",
                agent: "",
                logo: "",
                style: "",
                background: "",
                red: "",
                text1: "",
                text2: "",
                text3: "",
            },
            modeList: [
                { id: 1, name: "红包模式1" },
                { id: 2, name: "红包模式2" },
                { id: 3, name: "红包模式3" },
            ],
            batchList: [
                { id: 1, name: "产品批次1" },
                { id: 2, name: "产品批次2" },
                { id: 3, name: "产品批次3" },
            ],
            nameList: [
                { id: 1, name: "产品名称1" },
                { id: 2, name: "产品名称2" },
                { id: 3, name: "产品名称3" },
            ],
            agentList: [
                { id: 1, name: "代理商1" },
                { id: 2, name: "代理商2" },
                { id: 3, name: "代理商3" },
            ],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
        };
    },
    mounted() {
        // this.getList()
    },
    methods: {
        getList(){
            useList(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index){
            this.storePrams.page = index;
            this.getList();
        },
        // selection
        changeSelection(e){
            this.delData = e;
            if(this.dataTable.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            }
        },
        handleSelectAll(e){
            if(e == true){
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            }
        },
        // Drawer
        goChangeData(row){
            if(row.name){
                this.changeTitle = '编辑积分兑换';
            }else{
                this.changeTitle = '新增积分兑换';
            }
            this.changeModal = true;
        },
        cancelForm(){
            this.changeModal = false;
        },
        // 确定（提交表单）
        submitForm(){
            upList(this.formData).then( res => {
                this.getList();
                this.changeModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        goDel(index, row){
            if(index == 0 && this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    if(index == 0){
                        var del_id = [];
                        this.delData.forEach(item => {
                            del_id.push(item.id)
                        });
                        this.del_id = del_id.join(',');
                        delapi({ id: this.del_id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 1){
                        delapi({ id:row.id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        // 文件上传时
        handleProgress() {
            this.$Message.loading({
                content: '上传中...',
                duration: 0
            }) 
        },
        //文件上传类型错误
        handleFormatError() {                
            this.$Message.destroy();
            this.$Message.warning("暂不支持上传此格式");
        },
        // 上传成功
        logoSuccess(e) {    
            this.formData.logo = e.data.relative_path;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        styleSuccess(e) {    
            this.formData.style = e.data.relative_path;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        backgroundSuccess(e) {    
            this.formData.background = e.data.relative_path;
            this.$Message.destroy(); 
            this.$Message.success(e.msg);  
        },
        redSuccess(e) {    
            this.formData.red = e.data.relative_path;
            this.$Message.destroy(); 
            this.$Message.success(e.msg);  
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.form_title {
    margin-bottom: 24px;
    color: #484E66;
    font-weight: 600;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
}
.form_upload {
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px dashed #9FA5BB;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
::v-deep .ivu-checkbox{
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.form_img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
</style>